const withIntroductionComment = (introductionId, comment) => prevProject => {
    const index = prevProject.introductions.findIndex(
        introduction => introduction.id === introductionId,
    );

    if (index === -1) {
        return prevProject;
    }

    const newIntroductions = [...prevProject.introductions];

    newIntroductions[index] = {
        ...newIntroductions[index],
        comment,
    };

    return {
        ...prevProject,
        introductions: newIntroductions,
    };
};

export default withIntroductionComment;
